import { isEmpty, lowerCase, snakeCase, startCase } from 'lodash';
import { omitUndefined } from '../../../../object';

export const createMixpanelEvent =
    (type) =>
    ({
        collection = {},
        sourceInfo = {},
        actionName,
        tabName,
        nameChanged,
        descriptionChanged,
        viewFilter,
        shouldCopy,
        provider,
        sourceComponent,
        numberSavedDeliveries,
    } = {}) =>
        omitUndefined({
            type,
            userId: sourceInfo.userId,
            'Page Name': startCase(sourceInfo.name),
            'Collection Name': collection.name,
            'Has Description': !isEmpty(collection.description),
            'Owner Type': lowerCase(collection.ownerType),
            'Action Name': snakeCase(actionName),
            'Source Component': startCase(sourceComponent),
            'Tab Name': tabName,
            'Name Changed': nameChanged,
            'Description Changed': descriptionChanged,
            'View Filter': viewFilter,
            'Copy Selected': shouldCopy,
            Provider: provider,

            // Related to "Inspire" project
            'Number Saved Deliveries': `${numberSavedDeliveries}`, // using string, because otherwise it will be skipped on zeros
        });
